
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <h1 style={{color:"#43ACE7", textAlign:"center"}}>
            <strong >Täiskasvanute Ortodontia</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"500", textAlign:"start"}}></p>
            <div style={{display:"flow"}}>

              <div className='puhastus-photo' style={{float:"right"}}></div>
              <h2>
                Airflow hammaste puhastus
              </h2>
              <p>
                Kaasaegne ja õrn meetod, mis eemaldab tõhusalt katu, pigmentatsiooni ja biofilmi spetsiaalse pulbri, vee ja õhujoa abil, jättes hambad puhtaks ja siledaks.
  Breketravi ajal on Airflow eriti oluline, sest breketite ümber koguneb kergemini katt ja bakterid – regulaarne puhastus aitab ennetada kaariest, igemepõletikku ja valgeid laike hammastel.
              </p>
              <p>
                Airflow hammaste puhastusi teostab hügeeniõde Alla Grišina.
              </p>
            </div>
      </Container>
          </Container>

        </div>
    );
}